export default __webpack_public_path__ + "static/watch-601ff596319486c2bc926183df66d08b.png";